import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { Store } from '@ngrx/store';
import { AppStore } from '@store/app.store';
import { selectBasketProductCount } from '@store/product-basket/product-basket.selectors';
import { selectShoppingListCount } from '@store/shopping-list/shopping-list.selectors';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, TooltipModule, TranslatePipe],
    templateUrl: './header.html',
    styleUrl: './header.scss',
})
export class Header {
    // ==================== DEPENDENCIES ====================
    private store = inject(Store<AppStore>);

    // ==================== STATE ====================
    public basketItemCount = toSignal(this.store.select(selectBasketProductCount), { requireSync: true });
    public shoppingListCount = toSignal(this.store.select(selectShoppingListCount), { requireSync: true });
}
